import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import Login from "./components/Login/Login";
import PrivateRoute from "./PrivateRouter/PrivateRoute";
import PublicRoute from "./PublicRouter/PublicRouter";
import MainLayout from "./components/Content/MainLayout";
import Dashboard from "./components/Content/Dashboard";
import UserManagement from "./components/Content/UserManagement";
import UserInvestments from "./components/Content/UserInvestments";
import PayoutHistory from "./components/Content/PayoutHistory";
import Transactions from "./components/Content/Transactions";
import WithdrawalsManagement from "./components/Content/WithdrawalsManagement";
import DashboardPage from "./components/pages/DashboardPage";
import RechargeHistory from "./components/Content/RechargeHistory";
import UserBlockManagement from "./components/Content/UserBlockManagement";


const App = () => {
  const [isAllowed, setIsAllowed] = useState(null); // null = loading

  // Function to check auth status
  const checkAuth = () => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        setIsAllowed(false);
        return false;
      }
      const decoded = jwtDecode(token);
      const allowed = decoded.userId === "d60e5499-d8c0-43db-9cdc-22f06c4910c0";
      setIsAllowed(allowed);
      return allowed;
    } catch (err) {
      setIsAllowed(false);
      return false;
    }
  };

  useEffect(() => {
    // Initial check
    checkAuth();
    
    // Set up listener for storage changes (in case token changes in another tab)
    const handleStorageChange = () => {
      checkAuth();
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  if (isAllowed === null) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route element={<PublicRoute isAuthenticated={isAllowed !== false} />}>
          <Route path="/login" element={<Login onLoginSuccess={checkAuth} />} />
        </Route>

        {/* Private Routes */}
        <Route element={<PrivateRoute isAuthenticated={isAllowed !== false} />}>
          <Route
            path="/*"
            element={
              <MainLayout>
                <Routes>
                  {isAllowed && (
                    <>
                      <Route path="/dashboard" element={<DashboardPage />} />
                      <Route path="/transactions" element={<Transactions />} />
                    </>
                  )}

                  <Route path="/user-management" element={<UserManagement />} />
                  <Route path="/recharge-history" element={<RechargeHistory />} />
                  <Route path="/withdrawals-management" element={<WithdrawalsManagement />} />
                  <Route
                    path="/user-management/:userId/investments"
                    element={<UserInvestments />}
                  />
                  <Route
                    path="/user-management/:userId/payout-history"
                    element={<PayoutHistory />}
                  />
                  <Route path="/user-management/blocked-users" element={ <UserBlockManagement />} />
                  <Route
                    path="*"
                    element={
                      <Navigate
                        to={isAllowed ? "/dashboard" : "/user-management"}
                        replace
                      />
                    }
                  />
                </Routes>
              </MainLayout>
            }
          />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
};

export default App;